var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list',{attrs:{"layout1":_vm.layout1,"orderStatus":"1,2"}})}
var staticRenderFns = []

export { render, staticRenderFns }